<template>
  <div class="app-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'layout'
};
</script>
